<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
const IMAGES_ENDPOINT = process.env.VUE_APP_IMAGES;

export default {
  name: "ImageUploadInput",
  components: {
    ButtonWithLoadWebsite,
  },
  props: {
    className: [String, Object],
    label: {
      type: String,
      required: true,
    },
    fieldKey: {
      type: String,
      required: true,
    },
    existImgUrl: [String, Object, File],
  },
  data() {
    return {
      imagePreview: "",
      fileName: "",
    };
  },
  computed: {
    name() {
      const fileName = this.fileName;
      return fileName !== "" ? fileName : !fileName && this.imagePreview ? '' : "No file chosen";
    },
    imageUrl() {
      const imagePreview = this.imagePreview;
        return imagePreview
        ? imagePreview
        : require("@/assets/img/photo_icon.svg");
    },
  },
  methods: {
    async getImageDimensions(file) {
    let img = new Image();
    img.src = URL.createObjectURL(file);
    await img.decode();
    let width = img.width;
    let height = img.height;
    return {
        width,
        height,
    }
  },
    async onChange(file) {
      const {width, height } = await this.getImageDimensions(file);

      if (width < 50 && height < 50) {
        return this.$toast.error('Icon height and width must be at least 50px')
      };

      if (file.size > 2048000) {
        return this.$toast.error('Icon size must be less than 2Mb')
      }

      this.fileName = file.name;
      const reader = new FileReader();

      reader.onload = (event) => {
        this.imagePreview = event.target.result;

        this.$emit("change", {
          key: this.fieldKey,
          value: file,
          preview: event.target.result,
        });
      };

      reader.readAsDataURL(file);
    },
    clear() {
      this.imagePreview = "";
      this.fileName = "";
      this.$emit("change", {
        key: this.fieldKey,
        value: '',
      });
    },
  },
  mounted() {
    if (this.existImgUrl && typeof(this.existImgUrl) !== 'object' && this.existImgUrl !== 'null') {
      this.imagePreview = IMAGES_ENDPOINT + this.existImgUrl;
    };
  }
};
</script>

<template>
  <div class="chat_bot_photo">
    <div class="chat_bot_image-box" :class="className">
      <img :src="imageUrl" alt="" />
    </div>
    <div class="file-upload_input_box">
      <div v-if="!this.imagePreview" class="file-upload_input">
        <label>
          {{ label }}
          <input
            type="file"
            accept="image/jpeg, image/svg, image/svg+xml, image/tiff, image/png"
            class="visually-hidden"
            @change="onChange($event.target.files[0])"
          />
        </label>
      </div>
      <span class="file-upload_input_text --top">{{ name }}</span>
      <ButtonWithLoadWebsite
        v-if="this.imagePreview" 
        title="Remove file"
        @onClick="clear"
      />
      <span class="file-upload_input_text --bottom">{{ name }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.file-upload_input {
  position: relative;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #f8fafc;
  line-height: 24px;
  border-radius: 6px;
  padding: 4px 8px;
  border: 1px solid;
  background: #3056d3;
  transition: all ease-in-out 300ms;

  & label {
    cursor: pointer;
  }
}
.file-upload_input:hover {
  background: #fff;
  color: #3056d3;
  border: 1px solid #3056d3;
  cursor: pointer;
}
.file-upload_input_box {
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 559px) {
    flex-direction: column;
  }
}
.file-upload_input_text {
  color: #4f4f4f;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;

  &.--bottom {
    @media (max-width: 559px) {
      display: none;
    }
  }

  &.--top {
      @media (min-width: 560px) {
        display: none;
      }
    }
}
.chatbot_photo_text {
  color: #4f4f4f;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.chat_bot_photo {
  display: flex;
  align-items: center;
  gap: 16px;
}
.chat_bot_image-box {
  height: 67px;
  width: 67px;
  object-fit: cover;
  overflow: hidden;
  border-radius: 50%;

  & img {
    width: 100%;
    height: 100%;
  }

  &.empty_field {
    border: 1px solid red;
  }
}
</style>
